// extracted by mini-css-extract-plugin
export default {"squareRatio":"KPcD8a","content":"LNoWko","wideRatio":"YQJM_s"};